import { useState, useEffect } from 'react'

interface CountdownTimerProps {
  targetTime: number // Unix timestamp
  onComplete?: () => void
}

export function CountdownTimer({ targetTime, onComplete }: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState<number>(0)

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = Math.floor(Date.now() / 1000)
      const remaining = targetTime - now
      return Math.max(0, remaining)
    }

    setTimeLeft(calculateTimeLeft())
    let hasTriggeredComplete = false

    const interval = setInterval(() => {
      const remaining = calculateTimeLeft()
      setTimeLeft(remaining)
      
      if (remaining <= 0 && onComplete && !hasTriggeredComplete) {
        hasTriggeredComplete = true
        // Wait 15 seconds after timer expires for EventBridge to execute
        setTimeout(() => {
          onComplete()
        }, 15000)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [targetTime, onComplete])

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  if (timeLeft <= 0) {
    return <span className="text-blue-600 font-medium animate-pulse">Requeuing...</span>
  }

  return (
    <span className="text-orange-600 font-medium">
      Requeue in {formatTime(timeLeft)}
    </span>
  )
}